/*jshint esversion: 11 */
import sendApiRequest from '../helpers/axios-setup';

/**
 *
 * @returns {Promise}
 */
export async function getChildList(
  page,
  limit,
  {
    filter_dob_start_date = '',
    filter_dob_end_date = '',
    filter_name = '',
    filter_phone_number = '',
    filter_email_address = '',
    filter_roll_no = '',
    filter_gender = '',
    filter_address_location = '',
    filter_children = '',
    include_deleted = '',
    include_profile_completed = ''
  } = {},
  sorting_option = ''
) {
  try {
    const response = await sendApiRequest.get('/child', {
      params: {
        page: page,
        limit: limit,
        sorting_option: sorting_option,
        filter_dob_start_date,
        filter_dob_end_date,
        filter_name,
        filter_phone_number,
        filter_email_address,
        filter_roll_no,
        filter_gender,
        filter_address_location,
        include_deleted,
        include_profile_completed,
        filter_children
      }
    });
    return response.data?.data[0];
  } catch (e) {
    return null;
  }
}

/**
 *
 * @param {String} name
 * @param {String} email_address
 * @param {String} password
 * @param {String} phone_number
 * @param {Date} dob
 * @param {String} gender
 * @param {String} address
 * @param {String} address_location
 * @param {Array} parents
 * @param {String} mother_tongue
 * @param {Array} languages_spoken
 * @param {String} blood_group
 * @param {String} allergies
 * @param {String} good_habits
 * @param {String} bad_habits
 * @param {String} sleeping_pattern
 * @returns {Promise<Object>}
 */
export async function addNewChild(data) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.post('/child', data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

/**
 *
 * @param {String} childId
 * @returns
 */
export async function getChildInfo(childId) {
  try {
    const response = await sendApiRequest.get(`/child/${childId}`);
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

/**
 *
 * @param {String} childId
 * @param {String} name
 * @param {String} email_address
 * @param {String} password
 * @param {String} phone_number
 * @param {Date} dob
 * @param {String} gender
 * @param {String} address
 * @param {String} address_location
 * @param {Array} parents
 * @param {String} mother_tongue
 * @param {Array} languages_spoken
 * @param {String} blood_group
 * @param {String} allergies
 * @param {String} good_habits
 * @param {String} bad_habits
 * @param {String} sleeping_pattern
 * @returns {Promise<Object>}
 */
export async function updateChild(childId, data) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.put(`/child/${childId}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

/**
 *
 * @param {String} childId
 * @returns
 */
export async function getGalleryImages(childId, params) {
  try {
    const response = await sendApiRequest.get(`/child/gallery/${childId}`, {
      params
    });
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

/**
 *
 * @param {String} childId
 * @returns
 */
export async function deleteRestoreChild(childId, type) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.delete(`/child/${childId}`, {
      params: {
        type: type
      }
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

/**
 *
 * @param {String} childId
 * @param {String} imageId
 * @returns
 */
export async function deleteImageFromExecution(execution_id, image_id) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response = await sendApiRequest.delete(
      `/execution/${execution_id}/image/${image_id}`
    );
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }
  return responseMap;
}

export async function sendEmail(child_id) {
  try {
    const response = await sendApiRequest.post(
      `/child/profile/email/${child_id}`
    );
    return { response: response.data, error: null };
  } catch (e) {
    const message = e?.response?.data?.message || e.message || 'Unknown error';
    return { response: null, error: message };
  }
}


export async function createSurveyFromChild(child_id) {
  try {
    const response = await sendApiRequest.post(
      `/child/survey/${child_id}`
    );
    return { response: response.data, error: null };
  } catch (e) {
    console.log(e);
    const message = e?.response?.data?.message || e.message || 'Unknown error';
    return { response: null, error: message };
  }
}
